import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {PASearch} from "../PA.Core/PASearch";
import {ModelPowerMetricBO} from "./ModelPowerMetricBO";
import {WB_PowerMetricRelationshipRow} from "../PA.Core/PAdbSchemaRows";


export class ModelPowerMetricBOValidations{


    static ValidateFields(aBO: ModelPowerMetricBO): Promise<void> {
        return new Promise((resolve, reject)=> {
            let powerMetricRels: WB_PowerMetricRelationshipRow[] = aBO.WB_Model_PowerMetric.WB_PowerMetricRelationshipRows
            let totalWeight = 0
            let bEmptyModelFncn: boolean = false
            _.forEach(powerMetricRels, (aRel: WB_PowerMetricRelationshipRow) => {
                if(aRel.cif.DELETED_IND != "1") {
                    let weightVal = _.toNumber(aRel.cif.DEFAULT_WEIGHT)
                    totalWeight = totalWeight + weightVal
                    if(aRel.cif.WB_MODEL_FUNCTION_ID == 0 || aRel.cif.WB_MODEL_FUNCTION_ID == -1)
                        bEmptyModelFncn = true
                }
            })

            if(totalWeight != 1) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'totalWeightNot1',
                        type: MessageType.Error,
                        title: 'Total Default Weight must be equal to 1',
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            }
            if(bEmptyModelFncn) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ModelFunctionEmpty',
                        type: MessageType.Error,
                        title: 'Displacement Function needs to be selected for every Power Metric Function Display row.',
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            }
            resolve()
        })

    }
}
